import React from 'react';
import { PatientNotesResponse } from './data/getPatientNotesData';
import dayjs from 'dayjs';

type PatientNotesProps = {
  data: PatientNotesResponse;
};

const ReportPatientNoteRow = (props: PatientNotesProps) => {
  return (
    <tr>
      <td className="nucleus-row">{dayjs(props.data.NoteDate).format('MM/DD/YYYY - hh:mm A')}</td>
      <td className="nucleus-row left-align">{props.data.PatientName}</td>
      <td className="nucleus-row left-align">{props.data.Note}</td>
      <td className="nucleus-row center-align">{props.data.UserName ? props.data.UserName : 'N/A'}</td>
    </tr>
  );
};

export default ReportPatientNoteRow;
